import React, {useState} from "react";
import {Dialog, Transition} from "@headlessui/react";
import {ExclamationTriangleIcon, XMarkIcon} from "@heroicons/react/24/solid";
import AssignRiderModal from "./AssignRiderModal";

function PackageDeliveryAlert({id, jobId}: {id: string; jobId: string}) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const closeModal = () => setIsModalOpen(false);
  const openModal = () => setIsModalOpen(true);

  const handleReassignClick = () => {
    console.log("Initiating rider reassignment...");
    openModal();
  };

  const handleConfirmReassign = () => {
    console.log("Confirmed rider reassignment.");
    closeModal();
  };

  // Alert styles
  const alertStyle = {
    borderRadius: "8px",
    backgroundColor: "#FEF3F2",
    padding: "16px",
    margin: "0 0 16px 0",
    borderLeft: "4px solid #F04438",
  };

  const flexContainerStyle = {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  };

  const iconStyle = {
    height: "20px",
    width: "20px",
    color: "#F04438",
  };

  const messageTextStyle = {
    fontSize: "14px",
    fontWeight: 500,
    color: "#D92D20",
    flex: 1,
  };

  const reassignButtonStyle = {
    borderRadius: "8px",
    backgroundColor: "#FEF3F2",
    padding: "8px 16px",
    fontSize: "14px",
    fontWeight: 600,
    color: "#B42318",
    border: "1px solid #F04438",
    cursor: "pointer",
    ":hover": {
      backgroundColor: "#FEE4E2",
    },
  };

  return (
    <div style={alertStyle}>
      <div style={flexContainerStyle}>
        <ExclamationTriangleIcon style={iconStyle} aria-hidden="true" />
        <p style={messageTextStyle}>
          Rider is not available to deliver the package. Kindly reassign to
          another rider
        </p>
        <button style={reassignButtonStyle} onClick={handleReassignClick}>
          Reassign Rider
        </button>
      </div>

      <AssignRiderModal
        isOpen={isModalOpen}
        closeModal={() => setIsModalOpen(false)}
        id={id}
        jobId={jobId}
      />

      {/* <Transition appear show={isModalOpen} as={React.Fragment}>
        <Dialog as="div" onClose={closeModal}>
          <Transition.Child
            as={React.Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div
              style={{
                position: "fixed",
                inset: 0,
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                zIndex: 50,
              }}
            />
          </Transition.Child>

          <div
            style={{position: "fixed", inset: 0, overflowY: "auto", zIndex: 50}}
          >
            <Transition.Child
              as={React.Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel
                style={{
                  position: "fixed",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: "90%",
                  maxWidth: "400px",
                  backgroundColor: "white",
                  borderRadius: "12px",
                  padding: "24px",
                  boxShadow:
                    "0px 20px 25px -5px rgba(0, 0, 0, 0.1), 0px 10px 10px -5px rgba(0, 0, 0, 0.04)",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <button
                  onClick={closeModal}
                  style={{
                    display: "flex",
                    width: "100%",
                    padding: "4px",
                    justifyContent: "end",
                  }}
                >
                  <XMarkIcon style={{height: "15px", width: "15px"}} />
                </button>
                <ExclamationTriangleIcon
                  style={{
                    height: "72px",
                    width: "65px",
                    color: "#FE7F1F",
                  }}
                  aria-hidden="true"
                />

                <Dialog.Title as="h3" style={modalTitleStyle}>
                  Heads Up!
                </Dialog.Title>
                <p
                  style={{
                    fontSize: "14px",
                    color: "#667085",
                    textAlign: "center",
                    marginBottom: "24px",
                  }}
                >
                  Rider is not available to deliver the package. Kindly reassign
                  to another rider
                </p>

                <div style={modalButtonContainerStyle}>
                  <button
                    style={modalConfirmButtonStyle}
                    onClick={handleConfirmReassign}
                  >
                    Reassign Rider
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition> */}
    </div>
  );
}

export default PackageDeliveryAlert;
